export const BetaFeatureKey = Object.freeze({
  Snapdragon: 'snapdragon',
})

// The organization field this reads. Callers pass the current organization, which may be loading.
type BetaFeatureOrganization = { beta_feature_keys?: string[] | null }

export function hasBetaFeature(
  organization: BetaFeatureOrganization | null | undefined,
  featureKey: string
): boolean {
  return Array.isArray(organization?.beta_feature_keys)
    ? organization.beta_feature_keys.includes(featureKey)
    : false
}
